angular.module("app").controller("AddSkinPageController", [
    '$scope',
    'generalService',
    'errorHandler',
    'logger',
    'preloadedLanguages',
    function ($scope, generalService, errorHandler, logger, preloadedLanguages) {
        var init;

        (init = function () {
            $scope.skin = {
                id: "",
                url: "",
                name: "",
                basehost: "",
                defaultLang: "",
                languages: []
            };
        })();

        $scope.tooltip = {
            id: "",
            name: "",
            basehost: "",
            url: ""
        };

        $scope.languages = {
            all: angular.copy(preloadedLanguages.languages)
        };

        $scope.save = function () {
            var requestData = {
                skin: angular.copy($scope.skin)
            };

            var languages = requestData.skin.languages;

            requestData.skin.languages = [];

            languages.forEach(function (languageObj) {
                requestData.skin.languages.push(languageObj.id)
            });

            generalService.createSkin(requestData).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("Skin has been successfully created");
                        init();
                        $scope.add_skin_form && $scope.add_skin_form.$setPristine && $scope.add_skin_form.$setPristine()
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        }
    }
]);